/* eslint-disable react/prop-types */
import { Box, useMediaQuery } from "@mui/material";
import { Formik } from "formik";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import OrganizationStructure from "../../../components/common/OrganizationStructure/OrganizationStructure";
import OrganizationStructureOld from "../../../components/common/OrganizationStructure/OrganizationStructureOld";
import { OS_DROPDOWN_KEYS } from "../../../contants";
import useQueryParams from "../../../hooks/useQueryParams";
import { selectUserProfile } from "../../../redux/selectors/user";
import { isEmptyObj } from "../../../utils/helper";

function OrganizationSearch({
  values,
  handleChange,
  errors,
  setFieldValue,
  disabledOSKeys,
  selectedDate,
}) {
  const [shouldFetchOtherOS, setShouldFetchOtherOS] = useState(false);
  const { getQueryObject, getQueryParams, urlSearchParams } = useQueryParams();
  const userData = useSelector(selectUserProfile);

  const isMobile = useMediaQuery("(max-width: 768px)");

  // ✅ SAFE DATE PARSE
  const parsedDate = selectedDate
    ? new Date(selectedDate?.$d || selectedDate)
    : null;

  // ✅ DATE BASED FLOW SWITCH
  const isClusterFlow =
    parsedDate &&
    parsedDate.getTime() >= new Date("2026-04-01T00:00:00").getTime();

  // ✅ DYNAMIC COMPONENT
  const OSComponent = isClusterFlow
    ? OrganizationStructure
    : OrganizationStructureOld;

  const preselectOSKeys = () => {
    if (disabledOSKeys?.length && !isEmptyObj(userData)) {
      disabledOSKeys.forEach((key) => {
        if (userData[key]) {
          setFieldValue(key, userData[key]);
        }
      });
      setShouldFetchOtherOS(true);
    }
  };

  useEffect(() => {
    const queryObject = getQueryObject();

    if (!isEmptyObj(queryObject)) {
      const query = getQueryParams(queryObject)[0];

      OS_DROPDOWN_KEYS.forEach((key) => {
        setFieldValue(key, Number(query[key]));
      });

      setShouldFetchOtherOS(true);
    } else {
      OS_DROPDOWN_KEYS.forEach((key) => {
        if (!disabledOSKeys?.includes(key)) {
          setFieldValue(key, "");
        }
      });

      preselectOSKeys();
    }
  }, [urlSearchParams.toString(), disabledOSKeys, userData]);

  return (
    <OSComponent
      values={values}
      handleChange={handleChange}
      errors={errors}
      setFieldValue={setFieldValue}
      showZoneLocator={false}
      showTitle={false}
      containerStyle={{
        border: "none",
        padding: "0px 18px 0px 0px",
        display: "grid",
        gridTemplateColumns: isMobile ? "1fr" : "repeat(5, 1fr)",
        columnGap: isMobile ? "0px" : "10px",
        rowGap: isMobile ? "0px" : "0px",
        alignItems: "flex-start",
      }}
      required={false}
      useHiddenInput
      storeValuesInRedux
      shouldFetchOtherOS={shouldFetchOtherOS}
      disabledOSKeys={disabledOSKeys}
    />
  );
}

function OrganizationSearchWrapper({ disabledOSKeys, selectedDate }) {
  return (
    <Box
      sx={{
        width: "100%",
        "& .MuiInputBase-root": {
          height: "40px !important",
          fontSize: "14px",
          borderRadius: "8px",
        },
        "& .MuiInputLabel-root": {
          fontSize: "14px !important",
          fontWeight: "600",
          top: "-4px",
        },
        "& .MuiInputLabel-shrink": {
          top: "0px !important",
        },
        "& .MuiOutlinedInput-input": {
          padding: "8.5px 14px !important",
          height: "auto !important",
          fontSize: "14px",
        },
        "& .MuiOutlinedInput-notchedOutline": {
          borderRadius: "8px",
        },
        "& .MuiInputBase-input": {
          height: "auto !important",
          padding: "8.5px 14px !important",
          fontSize: "14px",
        },
      }}
    >
      <Formik initialValues={{}}>
        {({ values, errors, handleChange, setFieldValue }) => (
          <OrganizationSearch
            values={values}
            errors={errors}
            handleChange={handleChange}
            setFieldValue={setFieldValue}
            disabledOSKeys={disabledOSKeys}
            selectedDate={selectedDate}
          />
        )}
      </Formik>
    </Box>
  );
}

export default OrganizationSearchWrapper;
